import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import HttpService from "../services/httpService";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import GetAppOutlinedIcon from '@material-ui/icons/GetApp';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContentText,
  DialogContent,
  FormControl
} from "@material-ui/core";
import moment from "moment";
import TablePagination from "@material-ui/core/TablePagination";
import { Button } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom'
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import {
  Close,
  CheckCircle
} from "@material-ui/icons";
import Draggable from 'react-draggable';


function PaperComponent(props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 850,
  },
  tableHeader:{
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: "#2C2E3E"
  },
  // tableCell: { fontWeight: "800", textAlign:"center", color: 'white', minWidth: '150px' },
  tableCell: {
    padding: '4px',           
    textAlign: 'center',      
    color: 'white'
  },
  textField: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    width: 300
  },
  paper: {
    padding: "2rem 2rem 2rem 2rem",
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  heading: { margin: 'auto', textAlign: "center", color: "white", backgroundColor: "#2C2E3E", padding: 10, borderRadius: 50, width: "50%", fontSize: 20, marginBottom: 20},
  downloadCsvButton: {   backgroundColor: '#a7f2af', color: 'black', padding: '1', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', alignSelf: "center", marginBottom: 20, "&:hover": { backgroundColor: "#124a17", color: 'white' } },
  resetButton: { backgroundColor: 'white', color: 'black', padding: '1', marginRight: '2%', borderRadius: '20px', alignSelf: "center", marginLeft: 20, "&:hover": { backgroundColor: "#4f5052", color: 'white' } },
  filterButton: { backgroundColor: 'white', color: '#151921', padding: '1', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#14419c", color: 'white' } },
  searchInput: {
    borderRadius: '50px',
    borderColor: '#2196F3'
  },
  noArrow: {
    '& .MuiSelect-icon': {
      display: 'none',
    },
  },
  callButton: {
    backgroundColor: 'white',
    color: 'black',
    padding: '1',
    borderRadius: '20px',
    alignSelf: "center",
    "&:hover": { backgroundColor: "#124a17", color: 'white' }
  },
  downloadButton: {
    backgroundColor: 'white',
    color: 'black',
    padding: '1',
    borderRadius: '20px',
    alignSelf: "center",
    alignItems: 'center',
    "&:hover": { backgroundColor: "#121e5c", color: 'white' }
  },
  
  actionButton: {
    backgroundColor: 'white',
    color: 'black',
    padding: '1',
    borderRadius: '20px',
    alignSelf: "center",
    "&:hover": { backgroundColor: "#2c2e3e", color: 'white' }
  },
}));
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);
const CallCenterLogs = (props) => {
  const { userDetails } = useSelector(state => state.user)
  const [callCenterLogsData, setCallCenterLogsData] = useState([])
  const [selectedSearchType, setSelectedSearchType] = useState([]);
  const [searchTypes, setSearchTypes] = useState([ {name: 'Client Phone Number'}, {name: 'Agent Phone Number'}, {name: 'Call Status'}, {name: 'Call Direction'} ]);
  const [searchInput, setSearchInput] = useState("")
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCallLogsCount, setTotalCallLogsCount] = useState(0);
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [isFileUploaded, setIsFileUploaded] = useState(false)
  const [showCallActions, setShowCallActions] = useState(false)
  const [callAction, setCallAction] = useState('')
  const [currentCallDetails, setCurrentCallDetails] = useState({})
  const [remarks, setRemarks] = useState('')
  const [showFollowUpDialog, setShowFollowUpDialog] = useState(false)
  const [junkLeadAttachment, setJunkLeadAttachment] = useState('')
  const [currentContactNo, setCurrentContactNo] = useState('')
  const [nextFollowUpDate, setNextFollowUpDate] = useState(null)
  const [nextFollowUpTime, setNextFollowUpTime] = useState(null)
  const [followUpSelfData, setFollowUpSelfData] = useState([])


  const classes = useStyles();

  const handleDateChange = (e) => {
    setNextFollowUpDate(e.target.value);
  };

  const handleTimeChange = (e) => {
    setNextFollowUpTime(e.target.value);
  };

  const handle_remarks = async (e,v) => {
    try {
      // console.log('handle_remarks function called')
      // console.log('name: ', e.target.name, 'value: ', e.target.value)
      setRemarks(e.target.value)
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }
  
  const handle_call_center_logs = async () => {
    try {
      let response = await HttpService.get_call_center_logs(rowsPerPage)
      
      setCallCenterLogsData(response.data.result)
      setTotalCallLogsCount(response.data.totalCallCenterLogs)
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }
  const handle_filter_click = async (input) => {
    props.setLoading(true)
    try {
      let obj = {}
      obj.startDate = startDate
      obj.endDate = endDate
      obj.searchInput = searchInput
      obj.selectedSearchType = selectedSearchType
      obj.rowsPerPage = rowsPerPage
      if(input.newPage) {
        obj.newPage = input.newPage
      }
      if(input.newRowsPerPage) {
        obj.rowsPerPage = Number(input.newRowsPerPage)
      }
      let response = await HttpService.get_filtered_call_center_logs(obj)
      if(response.status == 202) {
        props.setLoading(false)
        props.setSnackInfo(response.data, 'error')
        return
      }
      setCallCenterLogsData(response.data.result)    
      setTotalCallLogsCount(response.data.totalCallCenterLogs)
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }
  const handle_search_type_selection = (value) => {
    setSelectedSearchType(value)
    setSearchInput('')
  }
  
  const handle_download_csv_click = async () => {
    props.setLoading(true)
    try {
      const wb = XLSX.utils.book_new();
      let callCenterLogsDataForCSV = []
      for(let i = 0; i < callCenterLogsData.length; i++) {
        let obj = {}
        obj['Sl. No'] = i+1
        obj['Client Phone Number'] = callCenterLogsData[i]['caller_number']
        obj['Agent Phone Number'] = callCenterLogsData[i]['agent_number']
        obj['Call Ringing Date'] = moment(callCenterLogsData[i]['call_date']).format('DD-MM-YYYY')
        obj['Call Ringing Time'] = callCenterLogsData[i]['call_time']
        obj['Call Duration'] = callCenterLogsData[i]['call_duration']
        obj['Call Recording Link'] = callCenterLogsData[i]['recording_url']
        obj['Call Direction'] = callCenterLogsData[i]['call_direction']
        obj['Call Status'] = callCenterLogsData[i]['call_status']
        
        callCenterLogsDataForCSV.push(obj)
      }
      const ws = XLSX.utils.json_to_sheet(callCenterLogsDataForCSV);
      XLSX.utils.book_append_sheet(wb, ws, 'Call Center Logs');
      XLSX.writeFile(wb, 'call-center-logs.xlsx');
    }
    catch(error)
    {
      console.log('error', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  const handle_change_page_click = (event, newPage) => {
    setPage(newPage);
    handle_filter_click({newPage: newPage})
  };
  const handle_change_rows_per_page_click = (event) => {
      setRowsPerPage(Number(event.target.value));
      setPage(0);
      handle_filter_click({newRowsPerPage: Number(event.target.value)})
  };
  const clearFilter = () => {
    setStartDate('')
    setEndDate('')
    setSelectedSearchType([])
    setSearchInput("")
    setPage(0)
    setRowsPerPage(10)
    handle_call_center_logs()
    
  }

  const handle_close_call_actions_dialog = async () => {
    try {
      // console.log('handle_close_call_actions_dialog function called')
      // props.setSnackInfo('handle_close_call_actions_dialog function called', 'success')
      setShowCallActions(false)
      setShowFollowUpDialog(false)
      setCurrentCallDetails({})
      setCallAction('')
      setRemarks('')
      setIsFileUploaded(false)
      setJunkLeadAttachment('')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handle_call_action = async (input) => {
    try {
      // console.log('handle_call_action function called, input: ', input)
      setCallAction(input)
      setShowFollowUpDialog(true)
      // props.setSnackInfo(`handle_call_action function called, input: ${input}`, 'success')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handle_action_click = async (input) => {
    try {
      let customer_number = input.caller_number.slice(3)
      setCurrentContactNo(customer_number)
      setCurrentCallDetails(input)
      setShowCallActions(true)
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const onImageChange = async (e) => {
    props.setLoading(true);
    const fd = new FormData();
    fd.append('file', e.target.files[0]);
    try {
      const fileUploadRes = await HttpService.uploadFile(fd);
      // console.log('fileUploadRes.data', fileUploadRes.data)
      setIsFileUploaded(true)
      setJunkLeadAttachment(fileUploadRes.data)
    } catch (err) {
      props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
    }
    props.setLoading(false);
  };

  const handle_call_action_submit = async () => {
    props.setLoading(true)
    try {
      // console.log('callAction', callAction)
      // console.log('nextFollowUpDate', nextFollowUpDate)
      // console.log('nextFollowUpTime', nextFollowUpTime)
      let data = {}
      data.customer_no = currentContactNo
      data.call_type = 'incoming'
      data.remarks = remarks
      if(callAction == 'moveToJunk') {
        data.call_status = 'junk'
        data.junkLeadAttachment = junkLeadAttachment
      } else if(callAction == 'moveToFollowUp') {
         data.call_status = 'follow_up_self'
         data.next_follow_up_date = new Date(`${nextFollowUpDate}T${nextFollowUpTime}:00`)
      }
      let result = await HttpService.updateCallCenterLead(data)
      // console.log('result', result.data)
      setShowFollowUpDialog(false)
      setShowCallActions(false)
      setNextFollowUpDate(null)
      setNextFollowUpTime(null)
      setCurrentContactNo('')
      setRemarks('')
      setIsFileUploaded(false)
      setJunkLeadAttachment('')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  const handle_send_to_manager = async () => {
    props.setLoading(true)
    try {
      // console.log('handle_send_to_manager function called')
      // console.log('currentContactNo', currentContactNo)
      // console.log('userDetails', userDetails)
      let result = await HttpService.sendCallCenterLeadToManager({remarks: remarks, customer_no: currentContactNo})
      const result2 = await HttpService.getFollowUpSelfData()
      // console.log('result2', result2.data)
      setFollowUpSelfData(result2.data)
      setShowFollowUpDialog(false)
      props.setSnackInfo(`Moved to Assistant Manager successfully!`, 'success')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  useEffect(() => {
    props.setLoading(true)
    handle_call_center_logs()
    props.setLoading(false)
  },[]);
  return (
    <div>
      <Button disabled={false} className={classes.downloadCsvButton} variant="outlined" onClick={handle_download_csv_click} >
        Download CSV
      </Button>
      <Paper style={{ textAlign: 'center', marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%', margin: 'Auto' }}>
          <TextField
            select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedSearchType}
            label="Select Type"
            name="searchType"
            onChange={(e) => handle_search_type_selection(e.target.value)}
            variant="outlined"
            style={{width: '50%', marginRight: '2%'}}
            size="small"
            className={classes.noArrow}
            >
            {searchTypes.map((el) =>(
              <MenuItem value={el}>{el.name}</MenuItem>
            ))}
          </TextField>
          <TextField label={`Enter your input`} name="searched" size="small" value={searchInput} onChange={(e) => {setSearchInput(e.target.value)}} variant="outlined" style={{width: '80%'}} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1%', marginBottom: '1%' }}>
          <TextField
              id="date"
              name="startDate"
              label="From Date"
              type="date"
              variant="outlined"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{
                  shrink: true,
              }}
              fullWidth
              className={classes.textField}
              style={{ width: '30%', marginRight: '2%', marginLeft: '2%' }}
              size="small"
          />
          <TextField
              id="date"
              name="endDate"
              label="Till Date"
              type="date"
              variant="outlined"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{
                  shrink: true,
              }}
              fullWidth
              className={classes.textField}
              style={{ width: '30%', marginRight: '2%', marginLeft: '2%' }}
              size="small"
          />
          <Button disabled={false} className={classes.filterButton} variant="outlined" style={{ alignSelf: "center", marginLeft: 20 }} onClick={handle_filter_click} >
                Filter
          </Button>
          <Button className={classes.resetButton} variant="outlined" onClick={()=>clearFilter()} >
                Reset
          </Button>
        </div>
      </Paper>
      <Paper style={{ textAlign: 'center', marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
        <TableContainer component={Paper}>
          <Table className="table table-responsive table-bordered" aria-label="sticky table">
            <TableHead>
              <StyledTableRow>
                <TableCell colSpan={11} style={{ padding: '0' }}>
                  <TablePagination
                    rowsPerPageOptions={[10, 50, 100, 500, { label: "All", value: totalCallLogsCount }]}
                    count={totalCallLogsCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handle_change_page_click}
                    onRowsPerPageChange={handle_change_rows_per_page_click}
                    style={{ display: 'flex', justifyContent: 'flex-start', border: 'none' }}
                  />
                </TableCell>
              </StyledTableRow>
              <StyledTableRow className={classes.tableHeader}>
                <TableCell className={classes.tableCell} style={{ width: '5%', fontSize: '12px' }}>S.No</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '2%', fontSize: '12px' }}>Client Phone Number</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '2%', fontSize: '12px' }}>Agent Phone Number</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '6%', fontSize: '12px' }}>Call Ringing Date</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '7%', fontSize: '12px' }}>Call Ringing Time</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '8%', fontSize: '12px' }}>Call Duration</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '8%', fontSize: '12px' }}>Call Recording Link</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '8%', fontSize: '12px' }}>Call Direction</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '8%', fontSize: '12px' }}>Call Status</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '10%', fontSize: '12px' }}>Current Status</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '10%', fontSize: '12px' }}>Last Remarks</TableCell>
                <TableCell className={classes.tableCell} style={{ width: '8%', fontSize: '12px' }}>Action</TableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {
                callCenterLogsData.map((row, i) => {
                  return (
                    <TableRow key={i + 1}>
                      <TableCell style={{textAlign:"center" }}>{i + 1}</TableCell>
                      <TableCell style={{textAlign:"center" }}>{row.caller_number ? row.caller_number : 'NA'}</TableCell>
                      <TableCell style={{textAlign:"center" }}>{row.agent_number ? row.agent_number : 'NA'}</TableCell>
                      <TableCell style={{textAlign:"center" }}>{row.call_date ? moment(row.call_date).format('DD-MM-YYYY') : 'NA'}</TableCell>
                      <TableCell style={{textAlign:"center" }}>{row.call_time ? row.call_time : 'NA'}</TableCell>
                      <TableCell style={{textAlign:"center" }}>{row.call_duration ? row.call_duration : 'NA'}</TableCell>
                      {row.recording_url && row.recording_url != "None" ?
                      <TableCell style={{textAlign:"center" }} onClick={() => window.open(row.recording_url)}>
                        <a
                        href={row.recording_url} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{ color: 'blue', textDecoration: 'none' }}
                        >
                          <Button className={classes.downloadButton} variant="outlined" onClick={null}>
                            <GetAppOutlinedIcon />
                          </Button>
                        </a>
                      </TableCell>
                      : <TableCell style={{ textAlign: "center", fontSize: '12px' }}>'NA'</TableCell>}
                    <TableCell style={{ textAlign: "center", fontSize: '12px' }}>{row.call_direction || 'NA'}</TableCell>
                    <TableCell style={{ textAlign: "center", fontSize: '12px' }}>{row.call_status || 'NA'}</TableCell>
                    <TableCell style={{ textAlign: "center", fontSize: '12px' }}>{row.current_status || 'NA'}</TableCell>
                    <TableCell style={{ textAlign: "center", fontSize: '12px' }}>{row.last_remarks || 'NA'}</TableCell>
                    <TableCell style={{ textAlign: "center", fontSize: '12px' }}>
                      {
                        row.call_direction == 'incoming' ?
                        <Button className={classes.actionButton} variant="outlined" onClick={() => handle_action_click(row)}>
                          Click
                        </Button> : null
                      }
                    </TableCell>
                </TableRow>
              )})}
            
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
              open={showCallActions}
              // fullWidth
              maxWidth="md"
              PaperComponent={PaperComponent}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                <IconButton onClick={() => handle_close_call_actions_dialog()} size="small">
                  <Close />
                </IconButton>
              </div>
              <DialogActions>
                <Button className={classes.actionButton} onClick={null} variant="outlined">
                  <Link to='/create-new-lead' target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'none', textAlign: 'center' }}>Create Lead</Link>
                </Button>
                <Button className={classes.actionButton} onClick={null} variant="outlined">
                  <Link to='/CHM-Ticket-Creation' target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'none', textAlign: 'center' }}>Create Ticket</Link>
                </Button>
                <Button className={classes.actionButton} onClick={() => handle_call_action('moveToFollowUp')} variant="outlined">
                  Move To Follow-Up
                </Button>
                <Button className={classes.actionButton} onClick={() => handle_call_action('moveToJunk')} variant="outlined">
                  Move To Junk
                </Button>
              </DialogActions>

            </Dialog>
            <Dialog
              open={showFollowUpDialog}
              fullWidth
              PaperComponent={PaperComponent}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                <IconButton onClick={() => handle_close_call_actions_dialog()} size="small">
                  <Close />
                </IconButton>
              </div>
              <DialogTitle id="form-dialog-title" style={{ margin: "auto" }}>
                {/* Status : Call successfully placed */}
              </DialogTitle>
                  {callAction == 'moveToFollowUp' &&
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '10px' }}>
                    <TextField
                    id="next_follow_up_date"
                    label="Next Follow-Up Date"
                    type="date"
                    value={nextFollowUpDate}
                    onChange={handleDateChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    style={{ width: '200px' }}
                    />
                    <TextField
                      id="next_follow_up_time"
                      label="Next Follow-Up Time"
                      type="time"
                      value={nextFollowUpTime}
                      onChange={handleTimeChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{ width: '200px' }}
                    />
                  </div>
                  }
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '10px', marginTop: '2%' }}>
                  <TextField
                    id="remarks"
                    name="remarks"
                    type="text"
                    variant="outlined"
                    placeholder="Remarks"
                    onChange={(e, v) => handle_remarks(e, v)}
                    value={remarks}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // className={classes.ref_id_from_bank_field}
                    style={{ width: '400px' }}
                  />
                  {
                    callAction == 'moveToJunk' &&
                    <div>
                      <FormControl fullWidth margin="normal">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                            <TextField
                              accept="*"
                              id="contained-button-file"
                              type="file"
                              onChange={onImageChange}
                              style={{ display: 'none' }}
                            />
                            <label htmlFor="contained-button-file" style={{ display: 'flex', alignItems: 'center', marginLeft: 10 }}>
                              <Button className={classes.yesButton} variant="outlined" component="span">
                                Upload File
                              </Button>
                              {isFileUploaded && (
                                <CheckCircle style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />
                              )}
                            </label>
                          </div>
                        </FormControl>
                    </div>
                  }
                </div>
                
              <DialogActions>
                {
                  callAction != 'sentToManager' &&
                  <Button disabled={!remarks || (callAction == 'moveToFollowUp' && (!nextFollowUpDate || !nextFollowUpTime))} className={classes.actionButton} onClick={() => handle_call_action_submit()} variant="outlined">
                    Submit
                  </Button>
                }

                {
                  callAction == 'sentToManager' &&
                  <Button disabled={!remarks} className={classes.filterButton} onClick={() => handle_send_to_manager()} variant="outlined">
                    Submit
                  </Button>
                }
              </DialogActions>
            </Dialog>
      </Paper>
    </div>
  );
};
export default connect(null, { setLoading, setSnackInfo })(CallCenterLogs);